import { render } from "./FacilitatorActions.vue?vue&type=template&id=b4871a26"
import script from "./FacilitatorActions.vue?vue&type=script&lang=js"
export * from "./FacilitatorActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__